const forms = {
  state: {
    material: null,
    materialDID: null,
    materialRegister: null,
    materialRegisterTree: null,
    materialRegisterCounter: null,
    materialRegisterTreeCounter: null,
    materialList: null,
    materialListCounter: null
  },
  mutations: {
    changeMaterialRegister(state, payload) {
      state.materialRegister = payload;
    },
    changeMaterialRegisterTree(state, payload) {
      state.materialRegisterTree = payload;
    },
    changeMaterialList(state, payload) {
      state.materialList = payload;
    },
    changeMaterialRegisterCounter(state, payload) {
      state.materialRegisterCounter = payload;
    },
    changeMaterialListCounter(state, payload) {
      state.materialListCounter = payload;
    },
    changeMaterialRegisterTreeCounter(state, payload) {
      state.materialRegisterTreeCounter = payload;
    },
    changeMaterial(state, payload) {
      state.material = payload;
    },
    changeMaterialDID(state, payload) {
      state.materialDID = payload;
    }
  },
  actions: {
    changeMaterialRegister({ commit }, payload) {
      commit("changeMaterialRegister", payload);
    },
    changeMaterialRegisterTree({ commit }, payload) {
      commit("changeMaterialRegisterTree", payload);
    },
    changeMaterialList({ commit }, payload) {
      commit("changeMaterialList", payload);
    },
    changeMaterialRegisterCounter({ commit }, payload) {
      commit("changeMaterialRegisterCounter", payload);
    },
    changeMaterialRegisterTreeCounter({ commit }, payload) {
      commit("changeMaterialRegisterTreeCounter", payload);
    },
    changeMaterialListCounterCounter({ commit }, payload) {
      commit("changeMaterialListCounter", payload);
    },
    changeMaterial({ commit }, payload) {
      // commit to store
      commit("changeMaterial", payload);
    },
    changeMaterialDID({ commit }, payload) {
      // commit to store
      commit("changeMaterialDID", payload);
    }
  },
  getters: {
    getMaterialRegister: state => {
      return state.materialRegister;
    },
    getMaterialRegisterTree: state => {
      return state.materialRegisterTree;
    },
    getMaterialList: state => {
      return state.materialList;
    },
    getMaterialRegisterCounter: state => {
      return state.materialRegisterCounter;
    },
    getMaterialRegisterTreeCounter: state => {
      return state.materialRegisterTreeCounter;
    },
    getMaterialListCounter: state => {
      return state.materialListCounter;
    },
    getMaterial: state => {
      return state.material;
    },
    getMaterialDID: state => {
      return state.materialDID;
    }
  }
};
// eslint-disable-next-line
export default forms;
